import { render, staticRenderFns } from "./Infos.vue?vue&type=template&id=557e77da&scoped=true"
import script from "./Infos.vue?vue&type=script&lang=js"
export * from "./Infos.vue?vue&type=script&lang=js"
import style0 from "./Infos.vue?vue&type=style&index=0&id=557e77da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557e77da",
  null
  
)

export default component.exports